import PropTypes from "prop-types";
import { memo, useCallback } from "react";
import { ficheProduitPropTypes } from "app/utils/propTypes.js";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import {
	FLIGHT_OPTIONS_STATUS,
	PRODUCT_PAGE_CODE_STATUS,
	QUOTATION_CODE_STATUS,
} from "app/constants";
import ContactUs from "app/pages/.shared/ContactUs/ContactUs";
import IconBookingAsideLoader from "app/pages/.shared/IconBookingAsideLoader";
import CondensedBookWithConfidence from "app/pages/.shared/BookWithConfidence/CondensedBookWithConfidence";
import HolidaySummaryContainer from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummaryContainer";
import Button from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import "./BookingAside.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import Separator from "app/pages/.shared/Separator";
// eslint-disable-next-line no-unused-vars
import * as React from "react";
import PayNowNote from "app/pages/.shared/PayNow/PayNowNote";

const BookingAside = ({
	shop = "",
	ficheProduit = {},
	showQuotationCTAButton = false,
	showContactUs = false,
	showPriceDetails = false,
	showProductPicture = false,
	quotation = {},
	depositPercentage,
	isSubmitting = false,
	isBookingEligibleForDeposit,
	availablePaymentMethods = [],
	availablePaymentTerms = [],
	isPagePayment,
	total,
}) => {
	const [, countryCode] = shop.split("-");

	const handleCTAClick = useCallback(() => {
		document.querySelector(".quotation__button > button").click();
	}, []);

	const isQuoteLoading =
		quotation.status === QUOTATION_CODE_STATUS.LOADING ||
		quotation.flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING;

	const isCTALoading = isSubmitting || isQuoteLoading;
	const payNowNote = total > 0 && (
		<PayNowNote
			total={total}
			depositPercentage={depositPercentage}
			availablePaymentMethods={availablePaymentMethods}
			displayAmountSuffix={false}
		/>
	);

	let paymentDescriptionTermsContent;
	if (shop === "en-GB") {
		if (isBookingEligibleForDeposit) {
			paymentDescriptionTermsContent = payNowNote;
		}
	} else {
		paymentDescriptionTermsContent = <PaymentDescriptionTermsContainer />;
	}

	return (
		<div className="booking-aside">
			{ficheProduit.status === PRODUCT_PAGE_CODE_STATUS.SUCCESS ? (
				<div className="booking-aside__panel booking-aside__panel--my-booking">
					<HolidaySummaryContainer
						showBookingBanner
						showProductPicture={showProductPicture}
					/>
				</div>
			) : (
				<IconBookingAsideLoader />
			)}

			<div style={{ position: "sticky", top: "0" }}>
				<div className="booking-aside__panel booking-aside__panel--price-detail">
					{showPriceDetails && !isQuoteLoading && <QuotationPriceDetailContainer />}
					{!isPagePayment &&
						paymentDescriptionTermsContent &&
						availablePaymentTerms?.length > 0 && (
							<>
								<Separator design="middle" />
								{paymentDescriptionTermsContent}
							</>
						)}

					{showQuotationCTAButton && (
						<Button
							variant="primary"
							onClick={handleCTAClick}
							disabled={isCTALoading}
							loading={isCTALoading}
						>
							<FormattedMessage id="quotation.button.cta" />
							<IconRight width={16} height={16} style={{ marginLeft: 8 }} />
						</Button>
					)}
				</div>

				{countryCode === "GB" && (
					<div className="booking-aside__atol-abta">
						<CondensedBookWithConfidence />
					</div>
				)}

				{showContactUs && (
					<div className="booking-aside__panel booking-aside__panel--contact">
						<ContactUs productReference={ficheProduit.id} />
					</div>
				)}
			</div>
		</div>
	);
};

BookingAside.propTypes = {
	isBookingEligibleForDeposit: PropTypes.bool,
	shop: PropTypes.string,
	ficheProduit: ficheProduitPropTypes,
	showQuotationCTAButton: PropTypes.bool,
	showContactUs: PropTypes.bool,
	showPriceDetails: PropTypes.bool,
	quotation: PropTypes.object,
	showProductPicture: PropTypes.bool,
	depositPercentage: PropTypes.number,
	isSubmitting: PropTypes.bool,
	availablePaymentTerms: PropTypes.array,
	availablePaymentMethods: PropTypes.array,
	isPagePayment: PropTypes.bool,
	total: PropTypes.number,
};

export default memo(BookingAside);
